<template>
  <el-result title="404" :sub-title="$t('error.pageNotFound')"> </el-result>
</template>
